<script setup>
import {ref, onMounted, provide} from "vue";
import NeedsAIChat from "@/views/needs/chat/NeedsAIChat.vue";
import NeedsOnboarding from "@/views/needs/NeedsOnboarding.vue";
import needsService from "@/services/needs.service";
import NeedsUpdates from "@/views/needs/needs/NeedsUpdates.vue";
import NeedItem from "@/views/needs/needs/NeedItem.vue";

const chat = ref(null);
const onboardingCompleted = ref(false);

const needs = ref(null);

onMounted(() => {
    getNeeds();
    getOnboardingStep();
})

async function getOnboardingStep() {
    const {data} = await needsService.getOnboardingStep();

    if (data > 3) {
        onboardingCompleted.value = true;
    }
}

async function getNeeds() {
    const {data} = await needsService.getIndexList();
    needs.value = data;
}

provide('needs', needs)
</script>

<template>
    <div>
        <NeedsOnboarding @completed="onboardingCompleted = true"/>

        <div v-if="onboardingCompleted" class="needs-page">
            <NeedsUpdates/>

            <template v-if="needs?.length">
                <h3 class="heading3 heading3--needs">My Needs</h3>
                <div class="add-need-wrapper mb-4 mb-sm-5">
                    <a @click="chat.open()" class="link-add-need">Add New Need</a>
                </div>

                <NeedItem
                    v-for="need in needs"
                    :key="need.id"
                    :need="need"
                />
            </template>

            <div v-else>
                <ul class="needs-steps">
                    <li class="needs-steps__search"><p>Enter your business challenges</p></li>
                    <li class="needs-steps__ai"><p>We'll use AI to match you with startup solutions tailored to your need</p></li>
                    <li class="needs-steps__ecosystem"><p>Partnered Ecosystems will suggest proprietary startups on their roster</p></li>
                </ul>


                <h3 class="heading3 text-center">Add your needs and we’ll do the rest!</h3>

                <div class="add-need-wrapper text-center mb-5">
                    <a @click="chat.open()" class="link-add-need">Add New Need</a>
                </div>
            </div>

            <NeedsAIChat ref="chat"/>
        </div>
    </div>
</template>

<style scoped>
</style>
